<script>
    import { apiMethods } from "../../Services/index.svelte";

    import {
        ErrorModal,
        PageHead,
        PageLoading,
    } from "../../Components/Common/index.svelte";

    import {
        getAnnouncementsType,
        getFormatDate,
        getText,
        goToURL,
        showError,
        showException,
    } from "../../Utils/utilFunctions.svelte";
    import CardLayout from "../../Components/Common/CardLayout.svelte";
    import Button from "../../Components/Common/Button.svelte";

    export let params;

    let isLoadingAnnouncement = false,
        announcementDetails = {},
        isUpdatingAnnouncement = false;


    $: if (params.id) loadAnnouncement(params.id);

    const loadAnnouncement = async (id) => {
        isLoadingAnnouncement = true;

        await apiMethods.getMethod
            .getAnnouncementById(id)
            .then((res) => {
                if (!res.id || res.error)
                    showError(
                        "Failed to load announcement, please try again later or contact support",
                    );
                else announcementDetails = { ...res };
            })
            .catch((err) => showException(err));

        isLoadingAnnouncement = false;
    };

    const updateAnnouncement = async () => {
        isUpdatingAnnouncement = true;

        await apiMethods.putMethod
            .updateAnnouncement(announcementDetails)
            .then((res) => {
                if (!res || !res.id || res.error)
                    showError(
                        "Failed to update announcement, please refresh the page and try again and contact support if the issue persists.",
                    );
                else goToViewPage();
            })
            .catch((err) => showException(err));

        isUpdatingAnnouncement = false;
    };

    const goToViewPage = () => goToURL(`/Announcements/view/${params.id}`);

</script>

<PageHead
    title="Edit Announcement"
/>

{#if isLoadingAnnouncement}
    <PageLoading />
{:else}
    <div class="flex flex-col gap-2">
        <CardLayout title="Edit announcement">
            <div class="flex flex-col gap-2 p-2">
                <div
                    class="flex flex-col flex-1 px-2 py-4 gap-y-4 w-full lg:flex-row"
                >
                    <div
                        class="flex flex-col flex-1 gap-y-4 h-full"
                    >
                        <div class="flex gap-x-4">
                            <p class="title">ID:</p>

                            <p class="content">
                                {getText(announcementDetails.id)}
                            </p>
                        </div>

                        <div class="flex gap-x-4">
                            <p class="title">Type:</p>

                            <p class="content">
                                {getAnnouncementsType(
                                    announcementDetails.type,
                                )}
                            </p>
                        </div>
                    </div>

                    <div class="divider lg:divider-horizontal" />

                    <div
                        class="flex flex-col flex-1 gap-y-4 h-full"
                    >
                        <div class="flex gap-x-4">
                            <p class="title">Create Date:</p>

                            <p class="content">
                                {getFormatDate(
                                    announcementDetails.createdDate,
                                )}
                            </p>
                        </div>

                        <div class="flex gap-x-4">
                            <p class="title">Last Update Date:</p>

                            <p class="content">
                                {getFormatDate(
                                    announcementDetails.updatedDate,
                                )}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="flex flex-col flex-1 px-2 mt-4 gap-2">
                    <p class="title">Subject:</p>
                    <input
                        type="text"
                        bind:value={announcementDetails.subject}
                        class="content input input-bordered input-sm ml-2"
                        autocomplete="off"
                        disabled={isUpdatingAnnouncement}
                    />
                </div>

                <div class="flex flex-col flex-1 px-2 my-4 gap-2">
                    <p class="title">Content:</p>
                    <textarea
                        bind:value={announcementDetails.content}
                        class="content textarea textarea-bordered ml-2"
                        rows="3"
                        autocomplete="off"
                        disabled={isUpdatingAnnouncement}
                    />
                </div>
            </div>
        </CardLayout>
        <div class="flex justify-end">
            <Button
                clickFunc={updateAnnouncement}

            >
                Save Announcement
            </Button>
        </div>    
    </div>

{/if}

<style>
    .title {
        width: 150px;
    }

    .content {
        width: calc(100% - 150px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
